import { jwtDecode } from "jwt-decode";
import moment from "moment";

export const decodeToken = (token: any) => {
  const decodedJwtToken: any = jwtDecode(token);
  const tokenExpiryPeriodInSeconds = decodedJwtToken.exp - decodedJwtToken.iat;
  const tokenExpiryTime = decodedJwtToken.exp;
  const loggedInTimeStamp = new Date(decodedJwtToken.iat * 1000);
  // .toLocaleString().split(',')[0]
  // const loggedInDate =  `${(loggedInTimeStamp.getMonth() + 1)}/${loggedInTimeStamp.getDate()}/${loggedInTimeStamp.getFullYear()}`
  const loggedInDate = moment(loggedInTimeStamp).format("MM/DD/YYYY");
  const loggedInTime = moment(loggedInTimeStamp).format("h:mm a");
  const userDetails = {
    email: decodedJwtToken.sub,
    first_name: decodedJwtToken.first_name,
    last_name: decodedJwtToken.last_name,
    defaultRole: decodedJwtToken.default_role_name,
    loggedInDate,
    loggedInTime,
    exp: decodedJwtToken.exp,
    iat: decodedJwtToken.iat,
  };
  return { tokenExpiryPeriodInSeconds, tokenExpiryTime, userDetails };
};
